import React from "react"
import { Product } from "../../interfaces/product"
import { SingleSelect } from "./SingleSelect"
import { MenuPlacement } from "react-select"

export const ProductsList = ({
  selected,
  onSelect,
  flush,
  controlStyle,
  isDisabled,
  isClearable,
  name,
  menuPlacement,
  preventBlend,
  error,
}: {
  name?: string
  menuPlacement?: MenuPlacement
  selected?: number
  flush?: boolean
  isDisabled?: boolean
  controlStyle?: any
  onSelect: Function
  isClearable?: boolean
  preventBlend?: boolean
  error?: any
}) => (
  <SingleSelect
    preventBlend={preventBlend}
    menuPlacement={menuPlacement}
    error={error && name && error[name]}
    isClearable={isClearable}
    selected={selected}
    controlStyle={controlStyle}
    onSelect={onSelect}
    flush={flush}
    isDisabled={isDisabled}
    endpoint="products?page_size=10000&ordering=code"
    label={(product: Product) => product.code ?? product.title}
  />
)
